const tooltips = {
  hirek: 'Új blog bejegyzés rögzíthető és a korábbiak karbantartása végezhető el ezen a felületen. Csak azok a helyszínek láthatóak a felhasználó számára, amelyeknek a szerepköre a felhasználóhoz van rendelve.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
